import { useState, useContext } from "react";
import {
  ErrorDialogContext,
  errorHandledSync,
} from "@/shared/context/error-context";
import { useInstitutionsContext, InstitutionsService } from "@/features/institutions/contexts/institutions-context";
import { useModalContext } from "@/shared/components/modal/contexts/modal-context";
import { usePaymentContext } from "@/features/accounts/payment/scraping/contexts/payment-context";

export const useAddNewAccount = () => {
  const {
    setAuthType,
    setInstitutionsServices,
  } = useInstitutionsContext();
  const {
    setOpenHomeModal,
  } = useModalContext();
  const {
    setProcessType,
  } = usePaymentContext();
  const [accountType, setAccountType] = useState<string>("");
  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  const openAuthorizationModals = (
    institutionsService: InstitutionsService,
  ) => {
    // 銀行
    if (institutionsService.industryCode === "01") {
      // 全て認可サイトへ遷移
      setAuthType("bank");
      setOpenHomeModal("SiteAuth");
    }

    // クレカ
    else if (institutionsService.industryCode === "03") {
      if (institutionsService.companyCode === "19659"  // JCBデビット
        || institutionsService.companyCode === "19660"  // JCB
      ) {
        // JCBは認可サイトへ遷移
        setAuthType("crecaApi");
        setOpenHomeModal("SiteAuth");
      }
      // MoneyLook
      else {
        if (institutionsService.scrapeType === 3) {
          // API版は認可サイトへ遷移
          setAuthType("crecaLookApi");
          setOpenHomeModal("SiteAuth");
        }
        else if (institutionsService.scrapeType === 2) {
          // スクレイピングはログイン情報入力モーダルへ
          setAuthType("crecaLookScrape");
          setProcessType("reg");
          setOpenHomeModal("PaymentLoginInfo");
        }
      }
    }

    // 電子マネー
    else if (institutionsService.industryCode === "10") {
      if (institutionsService.scrapeType === 3) {
        // API版は認可サイトへ遷移
        setAuthType("emoneyLookApi");
        setOpenHomeModal("SiteAuth");
      }
      else if (institutionsService.scrapeType === 2) {
        // スクレイピングはログイン情報入力モーダルへ
        setAuthType("emoneyLookScrape");
        setProcessType("reg");
        setOpenHomeModal("PaymentLoginInfo");
      }
    }

    // ECショップ
    else if (institutionsService.industryCode === "20") {
      // ECショップは全て認可サイトへ遷移
      setAuthType("ecshop");
      setOpenHomeModal("SiteAuth");
    }

    else {
      // エラー
      console.log("institutions-service-type-error");
    }
    setInstitutionsServices([]);
  };

  return {
    openAuthorizationModals: errorHandledSync(openAuthorizationModals, setError),
    accountType,
    setAccountType,
  }
}